import React from "react"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import Image from "./image"
import Hidden from "@material-ui/core/Hidden"

const Hero = () => {
  return (
    <Grid id="Home" container spacing={3} style={{ minHeight: 500 }}>
      <Hidden xsDown>
        <Grid
        item
        xs={12}
        container
        direction="column"
        justify="center"
        alignItems="center"
        >
          <div style={{ width: "50%" }}>
            <Image alt="Persoanlized health guidance" filename="IHC_Logo.png" />
          </div>
        </Grid>
      </Hidden>
      <Grid
        item
        xs={12}
        container
        direction="column"
        justify="center"
        alignItems="center"
      >
        <Typography variant="h4" color="primary" style={{ marginBottom: 20 }}>
          Personalized Healthcare, For You
        </Typography>

        <Typography variant="subtitle1" style={{ marginBottom: 30 }}>
        We are a team of therapists who help our clients identify, organize and navigate many of their health related needs.
        We take a unique approach to providing counseling services to address both your mental and physical health
        </Typography>
        <Button variant="contained" color="secondary" size="large" href="./discovery">
          Get Started
        </Button>
      </Grid>
    </Grid>
  )
}
export default Hero
